export default [
  {
    date: '13/09/2021',
    price: '43580.23000000'
  },
  {
    date: '14/09/2021',
    price: '43780.23000000'
  },
  {
    date: '15/09/2021',
    price: '42080.23000000'
  },
  {
    date: '16/09/2021',
    price: '45580.23000000'
  },
  {
    date: '17/09/2021',
    price: '50580.23000000'
  },
  {
    date: '18/09/2021',
    price: '43580.23000000'
  },
  {
    date: '19/09/2021',
    price: '35580.23000000'
  },
]